module.exports = __webpack_public_path__ + "static/media/email.ac7f6ff9.png";